import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppUpdateService } from './core/services/app-update/app-update.service';
import { ThemeService } from './core/services/theme/theme.service';
import deTranslations from '../../public/assets/i18n/de.json';
import enTranslations from '../../public/assets/i18n/en.json';

@Component({
  selector: 'app-root',
  template: '<router-outlet />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppComponent {
  private readonly appUpdateService = inject(AppUpdateService);
  // Eagerly inject to apply saved theme on startup
  private readonly themeService = inject(ThemeService);

  private translate = inject(TranslateService);

  constructor() {
    this.translate.setTranslation('de', deTranslations);
    this.translate.setTranslation('en', enTranslations);

    const savedLang = localStorage.getItem('app-language');
    if (savedLang === 'de' || savedLang === 'en') {
      this.translate.use(savedLang);
    }
  }
}
